import { COLORS } from "../../../../styles/variables"

export const CardItem = {
  padding: '20px',
  cursor: 'pointer',
}

export const CardImg = {
  height: '100px',
  width: '100px',
  objectFit: 'cover',
  borderRadius: '50%',
}

export const TypDescription = {
  fontWeight: 300,
  color: COLORS.SMOKEY_GREY,
}

export const TypCharacteristics = {
  display: '-webkit-box',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1,
  overflowWrap: 'anywhere', 
  
  '& span': {
    fontWeight: 400,
    paddingRight: '10px',
  },
}
